export const mockData: any = {
  success: true,
  message: 'Customers retrieved successfully',
  messageCode: 'S1401013',
  data: {
    page: 1,
    pageSize: 10,
    totalCount: 10,
    pages: 1,
    rows: [
      {
        repName: 'Ahmed Saleh',
        userId: '63381aba00040d62460cd738',
        customerId: '6866e53c98fcfd4a85645902',
        name: 'Abbas Ali Pharmacy',
        email: '',
        phone: '',
        country: 'EGYPT',
        province: 'CAIRO',
        city: 'AIN SHAMS',
        center: '',
        type: 'Pharmacy',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'A',
        mktClass: '',
        specialClass: '',
        targetedFrequency: 0,
        visits: 0,
        calls: 0,
      },
      {
        repName: 'Mohamed Abdelganey',
        userId: '63381afe00040d62460cd759',
        customerId: '6061c305f7606271c5c588a8',
        name: 'Abd Al Salam Gomaa',
        email: 'Abd Al Salam Gomaa',
        phone: '1222118230',
        country: 'EGYPT',
        province: 'CAIRO',
        city: 'DOWN TOWN',
        center: 'Retired',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'C',
        mktClass: 'B',
        specialClass: 'C',
        targetedFrequency: 1,
        visits: 0,
        calls: 0,
        address:
          '26WV+C8C, Gawad Housny, As Sahah, Abdeen, Cairo Governorate 4280142, Egypt',
      },
      {
        repName: 'Mohamed Abdelganey',
        userId: '63381afe00040d62460cd759',
        customerId: '5da5aa156e74fc0015575140',
        name: 'Abd Al-rahman Al-bishbeshy',
        email: 'Abd Al-rahman Al-bishbeshy',
        phone: '1097976634',
        country: 'EGYPT',
        province: 'CAIRO',
        city: 'EL-SAYEDA ZENAIB',
        center: 'Ahmed Maher Hospital',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'B',
        mktClass: 'A',
        specialClass: 'B',
        targetedFrequency: 1,
        visits: 0,
        calls: 0,
        address:
          '27Q2+X4J, Port Said, El-Darb El-Ahmar, Al-Darb Al-Ahmar, Cairo Governorate 4281074, Egypt',
      },
      {
        repName: 'Mohamed Abdelganey',
        userId: '63381afe00040d62460cd759',
        customerId: '5ddb975a9636e700178ef904',
        name: 'Abd Al-shafy Hasseb',
        email: 'Abd Al-shafy Hasseb',
        phone: '01224469874',
        country: 'EGYPT',
        province: 'CAIRO',
        city: 'EL-SAYEDA ZENAIB',
        center: 'Sayed Galal Hospital',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'A',
        mktClass: 'A',
        specialClass: 'A',
        targetedFrequency: 2,
        visits: 0,
        calls: 0,
        address:
          '306 Port Said St, حارة الحوش، رحبة عابدين، عابدين، محافظة القاهرة‬ 4281075, Egypt',
      },
      {
        repName: 'Ahmed Saleh',
        userId: '63381aba00040d62460cd738',
        customerId: '5fa109af55f91600172f6a41',
        name: 'Abd Allem Soltan',
        email: 'Abd Allem Soltan',
        phone: '1005186817',
        country: 'EGYPT',
        province: 'CAIRO',
        city: 'AIN SHAMS',
        center: 'Al - Matareya Teaching Hospital',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'A',
        mktClass: 'A',
        specialClass: 'A',
        targetedFrequency: 2,
        visits: 0,
        calls: 0,
        address:
          '40 Atfet Masgad Al Kadi, Ein Shams Al Gharbeyah, El Matareya, Cairo Governorate 4533483, Egypt',
      },
      {
        repName: 'Mohamed Abdelganey',
        userId: '63381afe00040d62460cd759',
        customerId: '61c9aec9f112877cf65dd62b',
        name: 'Abd El Kawi Mogazy',
        email: 'Abd El Kawi Mogazy',
        phone: '1282639410',
        country: 'EGYPT',
        province: 'CAIRO',
        city: 'KASR ELEINI',
        center: 'Retired',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'C',
        mktClass: 'B',
        specialClass: 'C',
        targetedFrequency: 1,
        visits: 0,
        calls: 0,
        address:
          '30 Al Sabaa Sqayat, Al Eini, El Sayeda Zeinab, Cairo Governorate 4260016, Egypt',
      },
      {
        repName: 'Eman Sayed',
        userId: '67a0b6ae4f45709219de2913',
        customerId: '629ab727f9972c3ec2a8cfde',
        name: 'Abd El-wahab Nasrat Bayoumi',
        email: 'Abd El-Wahab Nasrat Bayoumi',
        phone: '1090988656',
        country: 'EGYPT',
        province: 'GIZA',
        city: 'HARAM',
        center: 'El Azher University',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'B',
        mktClass: 'B',
        specialClass: 'B',
        targetedFrequency: 2,
        visits: 0,
        calls: 0,
        address:
          '2642+8W7, Khatem El-Morsaleen, Al Omraneyah Al Gharbeyah, Al Haram, Giza Governorate 3546110, Egypt',
      },
      {
        repName: 'Eman Sayed',
        userId: '67a0b6ae4f45709219de2913',
        customerId: '5da5bf106e74fc001557602c',
        name: 'Abd Elsamd Amin',
        email: 'Abd Elsamd Amin',
        phone: '111-502-7219',
        country: 'EGYPT',
        province: 'GIZA',
        city: 'HARAM',
        center: 'October University',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'A',
        mktClass: 'A',
        specialClass: 'A',
        targetedFrequency: 2,
        visits: 0,
        calls: 0,
        address:
          'XWFV+J4M, El-Tahrir, First 6th of October, Giza Governorate 3233024, Egypt',
      },
      {
        repName: 'Eman Sayed',
        userId: '67a0b6ae4f45709219de2913',
        customerId: '63b157ffcf9042266189829a',
        name: 'Abdallah Mohamed Fathy',
        email: 'Abdallah Mohamed Fathy',
        phone: '1118580185',
        country: 'EGYPT',
        province: 'GIZA',
        city: 'FAISAL',
        center: 'Kaser Alaini University',
        type: 'Doctor',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'B',
        mktClass: 'B',
        specialClass: 'B',
        targetedFrequency: 2,
        visits: 0,
        calls: 0,
        address:
          '259M+QQW, Nazlet Khalaf, Boulaq Al Dakrour, Giza Governorate 3710811, Egypt',
      },
      {
        repName: 'Eman Sayed',
        userId: '67a0b6ae4f45709219de2913',
        customerId: '6866efab98fcfd4a85652f54',
        name: 'Abdel Hay',
        email: '',
        phone: '',
        country: 'EGYPT',
        province: 'GIZA',
        city: 'FAISAL',
        center: '',
        type: 'Pharmacy',
        nationality: '',
        mainCenter: '',
        need: '',
        businessCategory: '',
        companyClass: 'A',
        mktClass: 'A',
        specialClass: 'A',
        targetedFrequency: 2,
        visits: 0,
        calls: 0,
      },
    ],
    filters: {
      countries: ['EGYPT'],
      provinces: [
        'ALEXANDRIA',
        'GIZA',
        ' DOWN TOWN ',
        'CAIRO',
        'BANI SUIF',
        'QENA',
      ],
      cities: [
        'HELWAN',
        ' EL-SAYEDA ZENAIB',
        'QENA',
        'EL DAHER',
        'MAADI',
        'EL DAHER ',
        ' HELWAN ',
        'HADAYEK ELKOBA',
        ' MOKATAAM',
        'AIN SHAMS',
        'HADAYEK EL AHRAM',
        'OCTOBER',
        ' MANIAL',
        'ELHAMAM',
        'EL-SAYEDA ZENAIB',
        'MOHANDESIN ',
        'GIZA',
        'AL-GEISH',
        'BANI SUIF',
        'DERGANA',
        'BORG EL-ARAB KING MARRIOT',
        'MONIB',
        'EL-MANDRA ',
        'GIZA SQUARE',
        'CAIRO',
        'HARAM',
        'DOWN TOWN',
        ' DOWN TOWN ',
        'EL WAILY',
        ' EL MARG',
        'EL FAGALA',
        'SHEIKH ZAYED',
        'FAISAL',
        ' AIN SHAMS',
        'ABBASIA',
        ' AL-GEISH ',
        'EL ZAWYA',
        'HAWAMDIA',
        'MOKATAAM',
        'EL BADRASHIN',
        'RADIO',
        'BAB EL SHEARIA',
        'KASR ELEINI',
        'MANIAL',
      ],
    },
    schema: [
      {
        type: 'single',
        name: 'repName',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'userId',
        dataType: 'information',
        ignore: true,
      },
      {
        type: 'single',
        name: 'customerId',
        dataType: 'information',
        ignore: true,
      },
      {
        type: 'single',
        name: 'name',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'email',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'phone',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'country',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'province',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'city',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'specialty',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'center',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'type',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'nationality',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'mainCenter',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'need',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'businessCategory',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'companyClass',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'mktClass',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'single',
        name: 'specialClass',
        dataType: 'information',
        ignore: false,
      },
      {
        type: 'group',
        name: 'GroupColumnTest',
        groupColumns: [
          {
            type: 'single',
            name: 'targetedFrequency',
            dataType: 'numeric',
            ignore: false,
          },
          {
            type: 'single',
            name: 'visits',
            dataType: 'numeric',
            ignore: false,
          },
          {
            type: 'single',
            name: 'calls',
            dataType: 'numeric',
            ignore: false,
          },
        ],
        ignore: false,
      },

      {
        type: 'single',
        name: 'address',
        dataType: 'information',
        ignore: false,
      },
    ],
  },
};
